import { flatten } from 'lodash';

function generateSquads(values: DistanceType[]): SquadType[] {
  const squads = values.map((distance) => distance.squads || []);
  return flatten(squads);
}

export { generateSquads };
